export default "__VITE_ASSET__d3757fa2__"